import { render, staticRenderFns } from "./WorkAddressActivity.vue?vue&type=template&id=055b4b23&scoped=true&"
import script from "./WorkAddressActivity.vue?vue&type=script&lang=js&"
export * from "./WorkAddressActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b4b23",
  null
  
)

export default component.exports